// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3DAVC","form":"styles_form__sDCsB"};